/**
 * Middleware to protect routes that require authentication
 * Redirect to /login if user is not authenticated
 * Validates session on both server and client side
 */
export default defineNuxtRouteMiddleware(async (to, from) => {
  const publicRoutes = [
    '/auth/login',
    '/failed',
    '/auth/sign-up',
  ]

  const isPublicRoute = publicRoutes.some(route => to.path.includes(route))

  // Allow access to public routes
  if (isPublicRoute) {
    return
  }
})
